export default "__VITE_ASSET__kCsWpg6e__"